"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelWatch = void 0;
exports.matchChannel = matchChannel;
class ChannelWatch {
    watched = [];
    storage;
    constructor(watchStorage) {
        this.storage = watchStorage;
        this.watched = watchStorage.loadList();
    }
    watch = (name) => {
        if (!name) {
            console.warn('[ddt] need a package name');
            return false;
        }
        const allChannels = Array.isArray(name) ? name : [name];
        allChannels.forEach(p => this.watchChannel(p));
        this.storage.saveList(this.watched);
        return true;
    };
    unwatch = (name) => {
        if (!name) {
            console.warn('[ddt] need a package name');
            return false;
        }
        const allChannels = Array.isArray(name) ? name : [name];
        allChannels.forEach(channel => this.unwatchChannel(channel));
        this.storage.saveList(this.watched);
        return true;
    };
    watching = (name) => {
        if (name) {
            return this.isChannelWatched(name);
        }
        return this.watched.slice();
    };
    setWatched = (newWatchList) => {
        this.watched = newWatchList;
    };
    isChannelWatched(name) {
        return this.watched.some(ch => matchChannel(ch, name));
    }
    watchChannel(name) {
        if (!isChannelNameValid(name)) {
            console.warn('[ddt] attempted to watch invalid package', name);
            return false;
        }
        if (!this.isChannelWatched(name)) {
            this.watched.push(name.toLowerCase());
        }
        return true;
    }
    unwatchChannel(name) {
        if (!isChannelNameValid(name)) {
            console.warn('[ddt] attempted to unwatch invalid package', name);
            return false;
        }
        this.watched = this.watched.filter(channel => !matchChannel(channel, name));
    }
}
exports.ChannelWatch = ChannelWatch;
function isChannelNameValid(name) {
    return /^[a-zA-Z0-9*.]+$/.test(name);
}
function matchChannel(channelName, matcher) {
    if (matcher.indexOf('*') >= 0) {
        // glob match
        if (channelName.match(matcher.replace(/\./g, '.').replace(/\*/, '.*'))) {
            return true;
        }
    }
    else {
        // string match
        if (channelName.toLowerCase() === matcher) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=watch.js.map